/* @flow */

import React from 'react';
import { Redirect } from 'react-router-dom';

import CostCentersReportView from 'tables/CostCentresReportView/CostCentresReportView';
import CostCenterDetailsPage from 'views/CostCenterDetailsPage/CostCenterDetailsPage';
import { allRoles } from 'permissions/general';
import { createNewCostCenter, updateEditCostCenter } from 'permissions/costCenter';
import { formulateUri } from 'tables/components/ReportView/state';

import CostCenterForm from '../forms/CostCenterForm/CostCenterForm';
import type { TypeComponent } from './types';
import { filterTradingAccountItem } from './utils/filters';
import { getStore } from '../services/ServiceRegistry';

const costCentreRoutes: Array<*> = [
  {
    path: '/cost-centers',
    title: 'general:document_titles.cost_centers.title',
    component: CostCentersReportView,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/cost-centers/create',
    title: 'general:document_titles.cost_centers.create',
    component: function createCostCenter(): TypeComponent {
      return <CostCenterForm mode="create" />;
    },
    exact: true,
    permissions: createNewCostCenter,
  },
  {
    path: '/cost-centers/edit',
    title: 'general:document_titles.cost_centers.edit',
    title_keys: ['details.name'],
    component({ location }) {
      const store = getStore(['costCenterDetailsStore'])[0];

      store.details = location.state;

      return <CostCenterForm mode="edit" costCenterData={location.state ? location.state : {}} />;
    },
    exact: true,
    permissions: updateEditCostCenter,
  },
  {
    path: '/cost-centers/:id',
    title: 'general:document_titles.cost_centers.detail',
    title_keys: ['details.name'],
    component: CostCenterDetailsPage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/cost-centers/account/:accountId',
    component: function AccountCostCentresTable(props: *): TypeComponent {
      return (
        <Redirect
          to={formulateUri('/cost-centers', {
            page: 1,
            filters: [
              ...filterTradingAccountItem({
                key: 'account',
                values: [props.match.params.accountId],
              }),
            ],
          })}
        />
      );
    },
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/cost-centers/:id/:actionType',
    title: 'general:document_titles.cost_centers.action_type',
    title_keys: ['details.name', 'currentActionDrawer'],
    component: CostCenterDetailsPage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/cost-centers/:costCentreId/projects',
    component: function ProjectsByCostCentreTable(props: *): TypeComponent {
      return (
        <Redirect
          to={formulateUri('/projects', {
            page: 1,
            filters: [{ key: 'cost_centre', values: [props.match.params.costCentreId] }],
          })}
        />
      );
    },
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/cost-centers/project/:projectId',
    component: function ProjectsByCostCentreTable(props: *): TypeComponent {
      return (
        <Redirect
          to={formulateUri('/cost-centers', {
            page: 1,
            filters: [{ key: 'project', values: [props.match.params.projectId] }],
          })}
        />
      );
    },
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/cost-centers/:costCentreId/assets',
    component: function AssetsByCostCentreTable(props: *): TypeComponent {
      return (
        <Redirect
          to={formulateUri('/assets', {
            page: 1,
            filters: [{ key: 'cost_centre', values: [props.match.params.costCentreId] }],
          })}
        />
      );
    },
    exact: true,
    permissions: allRoles,
  },
];

export default costCentreRoutes.map(item => ({
  ...item,
  store: ['costCenterDetailsStore', 'actionDrawerStore'],
}));
